import { Route, Routes } from 'react-router-dom'

import BessDashboardIndex from '@/features/bessDashboard/pages/BessDashboardIndex'
import NavigateToError from '@/features/error/pages/NavigateToError'

export default function BessDashboardRoutes() {
  return (
    <Routes>
      <Route index element={<BessDashboardIndex />} path="/" />

      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
